<template>
    <b-row class="tbl-row">
        <b-col sm="12" >
            <b-card >
                <b-row class="mt-sm-2">
                    <b-col sm="12">
                        <b-row>
                            <b-col sm="2">
                                <span class="pr-">
                                    <strong>총 {{ totalRows | numberComma }}건</strong>
                                </span>
                            </b-col>
                            <b-col sm="8"/>
                            <b-col sm="2">
                                <b-form-group label-cols-sm="5" label="" class="mb-0">
                                <b-form-select
                                    v-model="rowPage"
                                    :options="pageOptions"
                                ></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <!-- 목록 -->
                    <b-col sm="12" class="pt-sm-1" style="min-height: 790px">
                        <b-row>
                            <b-col sm="12">
                                <b-table
                                  outlined
                                  hover
                                  :fields="fields"
                                  :items="items"
                                  @row-clicked="onRowClicked"
                                  ref="extSiteTable"
                                  class="cursor-pointer"
                                >
                                    <template slot="use_yn" slot-scope="row">
                                        <c-switch type="text" variant="primary"
                                                v-model="row.item.use_yn"
                                                v-on:change="updateUseYn(row.item)"
                                                on="On" off="Off"
                                                :pill="true" :checked="true"/>
                                    </template>

                                </b-table>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row>
                    <!-- 페이징 -->
                    <b-col sm="12" class="pt-sm-1">
                        <b-row class="pb-sm-2">
                          <b-col sm="12" class="my-1">
                              <b-pagination
                                  v-model="currentPage"
                                  :total-rows="totalRows"
                                  :per-page="rowPage"
                                  :limit="limitPage"
                                  @input="findExtSite"
                                  align="center"></b-pagination>
                          </b-col>
                        </b-row>
                        <div style="position:absolute; top:8px; right: 15px;">
                          <b-button
                            type="button"
                            variant="primary"
                            @click="addSiteClicked">사이트 추가</b-button>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";

const moment = require("moment");

import cSwitch from '../../../../components/Switch';
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { EventBus } from "../../../event-bus";


Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: "veeFields",
});

export default {
    name: "extSiteList",
    components: {
        PulseLoader,
        cSwitch,
    },
    props: {
        queryParams: {},
        fullDate: {
            type: Array,
        },
    },
    created() {
        // 이벤트 버스 선언
        EventBus.$on("callFindExtSite", () => {
          this.findExtSite();
        });
    },
    data() {
        return {
            totalRows: 0,
            currentPage: 1,
            limitPage: 12,
            rowPage: 12,
            pageOptions: [12, 30, 50, 100],
            fields: [
                { key:'use_yn', label: "수집여부", thStyle:{ width:'14%' }},
                { key:'site_id', label: "사이트 ID", thStyle:{ width:'12%' }},
                { key:'site_name', label: "사이트명", thStyle:{ width:'29%' }},
                { key:'main_url', label: "메인 URL", thStyle:{ width:'45%' }},
            ],
            items: [],
            isDownload: false,
            item: {},
          clickedRowData: null,
        }
    },
    mounted() {
        this.findExtSite();
    },
    watch:{
      'clickedRowData'(){
        EventBus.$emit('callExtSiteDetail', this.clickedRowData);
      },
      'rowPage'(){
        //page 옵션값 변경시 1페이지로 설정 후 리스트 get
        this.currentPage = 1;
        this.findExtSite()
      }
    },
    methods: {

        // 외부 리포트 리스트 검색
        findExtSite() {
            this.queryParams.rowPage = this.rowPage;
            this.queryParams.currentPage = this.currentPage - 1;

            let param = encodeURI(JSON.stringify(this.queryParams));
          let data = new FormData();
            data.append("objs", param);

            this.getList(data);
        },

        getList(data) {
            var token = sessionStorage.getItem("myToken");

            this.$http
            .post("/api/select/extSiteList?access_token=" + token, data, null)
            .then((result) => {
                const { resultListCount, resultList } = result.data;
                this.totalRows = resultListCount;
                this.items = [];
                this.items = resultList;
                if (this.search_user_id !== "" && this.search_user_id !== undefined) {
                    this.$parent.rowSessionSelected();
                }
            });
        },
        updateUseYn(item) {
            var token = sessionStorage.getItem("myToken");

            var param = encodeURI(JSON.stringify(item));
            var data = new FormData();
            data.append('objs', param);

            this.$http.post('/api/update/updateExtSiteUseState?access_token='+token, data, null)
                .then((result) => {
                    const { data } = result;
                    if(data !== 'ok'){
                        swal.fire({
                            type: 'error',
                            title: '저장 중 오류가 발생하였습니다.',
                            showConfirmButton: false,
                            timer: 1500
                        })
                    }
            });
        },
      onRowClicked(item, index, e){
          this.clickedRowData = item;
          //window.scrollTo(0,0);
      },
      addSiteClicked(){
          EventBus.$emit('callNewExtSite');
      }

    },
}
</script>
<style lang="scss">
@media(min-width: 1400px) {
  .tbl-row{width: 51%;}
}
.cursor-pointer tbody tr{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/contents/extSite/component/ExtSiteList.vue